import { BaseSetupStepComponent } from '../base-setup-step-component';
import { YoutubeSetupInterface } from '../../../../ng-services/livestreams/YoutubeSetupInterface';

export class LivestreamSetupYoutubeComponent extends BaseSetupStepComponent {
    value!: YoutubeSetupInterface;

    onChange?: (params: { value: YoutubeSetupInterface }) => any;

    onSave(value: YoutubeSetupInterface) {
        this.value = value;

        this.onChange && this.onChange({ value });

        if (this.isValid) {
            this.emitClose();
        }
    }

    get isValid() {
        return Boolean(this.value?.streamKey);
    }

    get nameText() {
        return this.isValid ? 'YouTube Streaming Configuration' : 'Configure your YouTube Streaming Account';
    }

    get headingText() {
        return this.isValid
            ? `Streaming Key ${this.value?.streamKey}`
            : 'Connect your YouTube account or configure manually';
    }

    get descriptionText() {
        return this.isValid ? 'We will use this key when you start streaming from TradersYard Live' : '';
    }
}

angular.module('tradersyard').component('tyLivestreamSetupYoutubeComponent', {
    // language=HTML
    template: `
        <ty-livestream-wizard-section open="$ctrl.open" on-open-changed="$ctrl.onOpenChanged(open)">
            <name>{{$ctrl.nameText}}</name>
            <heading>{{$ctrl.headingText}}</heading>
            <description>{{$ctrl.descriptionText}}</description>
            <button-text>
                <span ng-if="!$ctrl.isValid">setup</span>
                <i class="fa fa-check-circle" ng-if="$ctrl.isValid"></i>
            </button-text>

            <wizard-body>
                <ty-livestream-setup-youtube-body-component value="$ctrl.value" close="$ctrl.emitClose()" on-save="$ctrl.onSave(setup)"/>
            </wizard-body>
        </ty-livestream-wizard-section>
    `,
    controller: LivestreamSetupYoutubeComponent,
    bindings: {
        ...BaseSetupStepComponent.bindings,
        onChange: '&',
        value: '<',
    },
});
